import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Currency, Strategy } from "@front/m19-api-client";
import { AlgoTargetButtonComponent } from "@m19-board/strategies/algo-target-button/algo-target-button.component";
import { StrategyEx } from "@front/m19-models";

@Component({
  selector: "app-algo-target-renderer",
  imports: [AlgoTargetButtonComponent],
  template: `
    @if (strategy) {
      <app-algo-target-renderer-v2
        [strategy]="strategy"
        [currency]="currency!"
        [isReadonly]="readonly"
        [locale]="locale!"
        [organizationId]="organizationId!"
        [addLabel]="addLabel"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlgoTargetGridRendererComponent implements ICellRendererAngularComp {
  strategy: StrategyEx | undefined;
  organizationId: number | undefined;
  locale: string | undefined;
  currency: Currency | undefined;
  readonly = false;
  addLabel = false;

  agInit(
    params: ICellRendererParams<Strategy> & {
      strategy: StrategyEx;
      locale: string;
      currency: Currency;
      readonly: boolean;
      minBid: number;
      averageDailyBudget: number;
      addLabel?: boolean;
      organizationId: number;
    },
  ): void {
    this.strategy = params.strategy;
    this.organizationId = params.organizationId;
    this.currency = params.currency;
    this.locale = params.locale;
    this.readonly = params.readonly;
    this.addLabel = !!params.addLabel;
  }

  refresh(_: ICellRendererParams<any, any, any>): boolean {
    return true;
  }
}
